import React from "react";
import { useParams, useSearchParams } from 'react-router-dom';
import './PrivacyFAQ.css'
import { Text } from "react-native-web";

export function PrivacyPolicyPage() {
    const {appName} = useParams();
    const [searchParam] = useSearchParams();
    const startDate = searchParam.get('startDate');
    return (
        <>
        <div className="Page">
            <div className="Page-Content">
                <h2> Privacy Policy for {appName}</h2>
                <small> Effective Date: {startDate} </small>
                <Text style={{color: 'white'}}>
                {`${appName} (“we,” “us,” or “our”) respects your privacy.\nThis Privacy Policy explains how we handle your information when you use our app.`}
                </Text>
            <TitleParagraphSection title='1. No Personal Data Collected' 
            text={`${appName} does not collect, store, or share any personal information.\nWe do not track users, require accounts, or gather analytics.`}
            />
            <TitleParagraphSection
            title='2. Local Data Storage'
            text={`All content you create or save within ${appName} is stored locally on your device\nor in your personal iCloud account,under your control.\nWe do not have access to this data.`}
            />

            <TitleParagraphSection
            title='3. No Cookies or Tracking'
            text={`${appName} does not use cookies, tracking technologies, or third-party analytics tools.`}
            />

            <TitleParagraphSection
            title='4. No Third-Party Data Sharing'
            text={`We do not share any user data with third parties because no data is collected.`}
            />

            <TitleParagraphSection
            title='5. Children’s Privacy'
            text={`${appName} is not intended for children under the age of 13.\nSince no data is collected, we do not knowingly collect personal information from children.`}
            />

            <TitleParagraphSection
            title='6. Data Protection Rights'
            text={`While ${appName} does not collect or process your data, we support the privacy rights of users\nin the United States, Canada, and Europe,\nincluding those provided under the GDPR and CCPA.`}
            />

            <TitleParagraphSection
            title='7. Changes to This Policy'
            text={`We may update this Privacy Policy occasionally.\nAny changes will be posted within the app or on our official website.\nContinued use of the app after updates means you accept the revised policy.`}
            />
            </div>
        </div>
        </>
    )


}

export function TitleParagraphSection({title, text, key}) {

    return (
        <div key={key}>
            <h2>
            {title}
            </h2>
            <Text style={{color: 'white', zIndex:'1'}}>
            {text}
            </Text>
        </div>
    )
}